export default __webpack_public_path__ + "static/media/actus-project.597bc067.jpg";